export const HUMAN = 'Homo sapiens';
